import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { useDrawer, RowTrigger } from "@grandvisionhq/common";
import { REVIEWS_EVENT_ID } from "@grandvisionhq/reviews";
import { useEventListener } from "@grandvisionhq/utils";
const ProductDetailReviewsCTA = ({ title }) => {
  const { toggle } = useDrawer();
  useEventListener(REVIEWS_EVENT_ID, toggle);
  const handleClick = () => {
    DataLayer.Events.pushDrawerEventToDataLayer({
      siteFeature: "reviews",
      interactionType: "reviews_click"
    });
    toggle();
  };
  return /* @__PURE__ */ React.createElement(RowTrigger, { title, onClick: handleClick, "data-t": "reviews-drawer-trigger" });
};
export {
  ProductDetailReviewsCTA
};
//# sourceMappingURL=ProductDetailReviewsCTA.js.map
